const rankings = [
  {
    rank: 1,
    title: '她的私密教学',
    category: '韩漫',
    heat: '本周热度 328.5万',
    status: '连载中',
    badge: 'TOP1',
    badgeColor: 'primary',
  },
  {
    rank: 2,
    title: '末日生存法则',
    category: '日漫',
    heat: '本周热度 286.2万',
    status: '已完结',
    badge: '经典',
    badgeColor: 'accent',
  },
  {
    rank: 3,
    title: '剑道独尊',
    category: '国漫',
    heat: '本周热度 241.8万',
    status: '连载中',
    badge: '飙升',
    badgeColor: 'primary',
  },
  {
    rank: 4,
    title: '甜蜜的陷阱',
    category: '韩漫',
    heat: '本周热度 198.3万',
    status: '连载中',
    badge: '新晋',
    badgeColor: 'accent',
  },
  {
    rank: 5,
    title: '诡异调查员',
    category: '日漫',
    heat: '本周热度 175.6万',
    status: '连载中',
    badge: '口碑',
    badgeColor: 'primary',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            人气排行
          </h2>
          <p className="text-sm text-foreground-500">虫虫漫画本周热门作品排行榜，看看大家都在追什么</p>
        </div>

        <div className="max-w-[720px] mx-auto">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 md:gap-4 p-4 rounded-xl transition-colors cursor-pointer group ${
                i === 0 ? 'bg-primary-50/80 border border-primary-200/60' : 'bg-background-50 border border-background-200/40 hover:border-primary-200/50'
              } ${i < rankings.length - 1 ? 'mb-3' : ''}`}
            >
              <div
                className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                <span className="text-sm md:text-base font-bold">{item.rank}</span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </span>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      item.badgeColor === 'primary'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-accent-100 text-accent-700'
                    }`}
                  >
                    {item.badge}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="whitespace-nowrap">{item.category}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="whitespace-nowrap">{item.heat}</span>
                  <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                  <span className="whitespace-nowrap">{item.status}</span>
                </div>
              </div>

              <div className="flex-shrink-0">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-500 group-hover:text-primary-500 transition-colors">
                  <i className="ri-arrow-right-s-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-6">
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer hover:text-primary-700 transition-colors whitespace-nowrap">
            查看完整榜单
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </div>
      </div>
    </section>
  );
}